import { render, staticRenderFns } from "./MentalHealthConcernsChart.vue?vue&type=template&id=4d21e62b&scoped=true&"
import script from "./MentalHealthConcernsChart.vue?vue&type=script&lang=js&"
export * from "./MentalHealthConcernsChart.vue?vue&type=script&lang=js&"
import style0 from "./MentalHealthConcernsChart.vue?vue&type=style&index=0&id=4d21e62b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d21e62b",
  null
  
)

export default component.exports